import { get } from 'lodash';

// Expect Contentful rich text -> content -> json
export default function hasInlineCta(json) {
  if (json == null || json.content == null) return false;
  return json.content.find(c => (
    c.nodeType === 'embedded-entry-block' && /^cta/.test(get(c, "data.target.fields.type['en-US']"))
  )) != null;
}
